export default function DetailSkeletonProdukContent() {
  return (
    <div className="w-full mx-auto flex flex-col lg:flex-row gap-8">
      <div className="w-full space-y-3 ">
        <div className="h-6 w-1/4 bg-gray-200 rounded animate-pulse mb-8" />
        <div className="h-4 w-full bg-gray-200 rounded animate-pulse" />
        <div className="h-4 w-11/12 bg-gray-200 rounded animate-pulse" />
        <div className="h-4 w-10/12 bg-gray-200 rounded animate-pulse" />
        <div className="h-4 w-full bg-gray-200 rounded animate-pulse" />
      </div>
    </div>
  );
}
